
<aside class="primary-sidebar" id="primary-sidebar">
  <row class="panel-heading">
    <column>
      <a href="/" :class="logoClass" :style="customLogoStyle" :title="'Go to ' + organizationName + ' Home'">
        <span class="sr-only">{{organizationName}}</span>
      </a>
    </column>

    <suffix>
      <button class="btn-icon light-grey collapse-sidebar-btn">
        <span class="icon arrow-double"></span>
        <span class="sr-only">Toggle Sidebar Menu</span>
      </button>
    </suffix>
  </row>

  <scroll-area class="sidebar">
    <template v-for="folder in bookmarkMenu.sortedBookmarkFolders">
      <control-group v-if="isDashboardFolder(folder)" :group-name="folder.name" :key="folder.id" list-style>
        <li>
          <search-input
            v-model="q"
            compress
            id="search-bookmark-dashboards"
            @input="updateDashboardLinks(q)"
            placeholder="Search...">
          </search-input>
        </li>
        <li v-for="link in dashboardBookmarkLinks" :key="link.id">
          <a :href="link.url" class="anchor">
            {{link.name}}
          </a>
        </li>
      </control-group>
      <control-group v-else :group-name="folder.name" :key="folder.id" list-style>
        <li v-for="link in folder.sortedBookmarkLinks" :key="link.id">
          <a :href="link.forHref" class="anchor">
            {{link.name}}
          </a>
        </li>
      </control-group>
    </template>
  </scroll-area>

  <div class="panel-footer align-right">
    <button type="button" @click="showConfigurationModal">
      Configure <span class="icon gear"></span>
    </button>

    <button type="button" @click="showAddBookmarkModal">
      Bookmark Page <span class="icon bookmark"></span>
    </button>
  </div>

  <configure-sidebar
      slot="modal"
      v-if="modalStateFor(vueModalID.configureSidebar, ModalStatus.Confirmation).isVisible"
      :state="modalStateFor(vueModalID.configureSidebar)"
      @toggle-modal="hideModal(vueModalID.configureSidebar)">
  </configure-sidebar>

  <add-sidebar-bookmark
      slot="modal"
      v-if="modalStateFor(vueModalID.addBookmark, ModalStatus.Confirmation).isVisible"
      :state="modalStateFor(vueModalID.addBookmark)"
      @toggle-modal="hideModal(vueModalID.addBookmark)">
  </add-sidebar-bookmark>
</aside>
